module.exports = __webpack_public_path__ + "static/img/xs4.8c1a2725.png";